import React from 'react'
import { Timeline } from 'antd'
import { filter, includes, isEmpty, join, map } from 'lodash'

import { EVENT_SUBTYPES } from '../constants'
import { formatCreatedByText } from '../utils'

import renderSimpleUpdateEvent from './render-simple-update-event'

const renderTreeSaveEvent = event => {
  const { subtype, original, changes, createdAt, createdBy } = event

  if (includes(subtype, EVENT_SUBTYPES.DELETE)) {
    return (
      <Timeline.Item key={event.id}>
        Deleted {original.name} <br />
        {formatCreatedByText(createdAt, createdBy.name)}
      </Timeline.Item>
    )
  }

  if (includes(subtype, EVENT_SUBTYPES.CREATE)) {
    return (
      <Timeline.Item key={event.id}>
        Created {changes.name}
        <br />
        {formatCreatedByText(createdAt, createdBy.name)}
      </Timeline.Item>
    )
  }

  if (subtype === EVENT_SUBTYPES.REPLACE) {
    if (!isEmpty(changes.replacements)) {
      return (
        <Timeline.Item key={event.id}>
          Replaced {original.name} with{' '}
          {join(map(changes.replacements, 'name'), ', ')} <br />
          {formatCreatedByText(createdAt, createdBy.name)}
        </Timeline.Item>
      )
    }
    return (
      <Timeline.Item key={event.id}>
        Replaced {original.name} with {changes.name} <br />
        {formatCreatedByText(createdAt, createdBy.name)}
      </Timeline.Item>
    )
  }

  if (subtype === EVENT_SUBTYPES.REVERT_REPLACE) {
    if (!isEmpty(original.replacements)) {
      return (
        <Timeline.Item key={event.id}>
          Reverted replace for {changes.name} with{' '}
          {join(map(original.replacements, 'name'), ', ')} <br />
          {formatCreatedByText(createdAt, createdBy.name)}
        </Timeline.Item>
      )
    }
    return (
      <Timeline.Item key={event.id}>
        Reverted replace for {changes.name} with {original.name} <br />
        {formatCreatedByText(createdAt, createdBy.name)}
      </Timeline.Item>
    )
  }

  const eventToRender = {
    ...event,
    original: {
      ...original,
      parent: join(
        filter(
          [original.grandParentName, original.parentName],
          item => !isEmpty(item),
        ),
        ' / ',
      ),
    },
    changes: {
      ...changes,
      parent: join(
        filter(
          [changes.grandParentName, changes.parentName],
          item => !isEmpty(item),
        ),
        ' / ',
      ),
    },
  }

  return renderSimpleUpdateEvent(eventToRender, 'name', [
    'parentId',
    'dietCategoryId',
    'grandParentId',
    'parentName',
    'grandParentName',
  ])
}

export default renderTreeSaveEvent
